import React from 'react';

function Pagina404() {
  return (
    <div>
      404
    </div>
  );
}

export default Pagina404;
